import React, { useEffect, useState } from "react";
import PlantillaScreen from "../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import {
  GetASD,
  GroupByForeignKey,
  GroupByPropCheck,
} from "../CreditoyCobranza/ReporteCobranza/Actions/GetContainer";
import { EjercicioByRange } from "../CreditoyCobranza/ReporteCobranza/Helper/EjercicioByRange";
import { PeriodoSelect } from "../CreditoyCobranza/ReporteCobranza/Helper/PeriodoSelect";
import { capitalizePalabras } from "../../Helpers/CapitalizePalabras";

// Filtro de Cartera en Tránsito (ejercicio, periodo, región y sucursal).
// Basado en FiltroDashboardCobranza para mantener la misma UX de filtros.
// No restringe por sucursales permitidas: usa directamente el catálogo
// completo que regresa GetASD (FUtiliti/GetAdrSucursalDepartamento).
const FiltroCarteraTransito = ({
  onExecute,
  boxState,
  onBoxChange,
  cargarfiltros = true,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const storedState = JSON.parse(localStorage.getItem("cartera_transito_filtro")) || {};
  const newejercicio = storedState.ejercicio || new Date().getFullYear();
  const newperiodo = storedState.periodo || new Date().getMonth() + 1;

  const [state, setState] = useState({
    adr:
      Array.isArray(storedState?.adr) && storedState?.adr?.some((item) => item.checked)
        ? storedState.adr.filter((item) => item.checked).map(({ idadr, adr }) => ({ idadr, adr }))
        : [],
    sucursal:
      Array.isArray(storedState?.sucursal) && storedState?.sucursal?.some((item) => item.checked)
        ? storedState.sucursal.filter((item) => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
        : [],
    ejercicio: newejercicio,
    periodo: newperiodo,
    pendientes: storedState.pendientes ?? 0,
  });

  const { data, adr, sucursal, departamento } = state;

  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltrosCarteraTransito-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  // Guarda el estado del filtro para recordarlo entre visitas a la pantalla.
  const guardarState = (state) => {
    localStorage.setItem("cartera_transito_filtro", JSON.stringify(state));
  };

  useEffect(() => {
    if (cargarfiltros)
      GetASD()
        .then((res) => {
          setState((prev) => ({
            ...prev,
            data: res,
          }));

          // Sin restricción por sucursales permitidas: solo se restaura lo
          // que el usuario ya tenía seleccionado (si lo hay). Antes esto
          // mandaba TODAS las regiones (GroupByProps sin filtrar), lo que
          // hacía que la primera carga automática de la pantalla trajera
          // todas las regiones aunque no hubiera ninguna marcada.
          const adrActiva = storedState.adr?.filter((a) => a.checked) || [];
          const sucursalActiva = storedState.sucursal?.filter((s) => s.checked) || [];

          onBoxChange("pv", {
            adr: adrActiva,
            sucursal: sucursalActiva,
            departamento: [],
          });
        })
        .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!data || data.length === 0) return;

    var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
    var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
    var newdepartamento = GroupByPropCheck(data, ["iddepartamento", "departamento"], false);

    const savedState = JSON.parse(localStorage.getItem("cartera_transito_filtro")) || {};

    if (Array.isArray(savedState.adr)) {
      newadr = newadr.map((item) => ({
        ...item,
        checked: savedState?.adr?.some((a) => a.idadr === item.idadr && a.checked),
      }));
    }

    if (Array.isArray(savedState.sucursal)) {
      newsucursal = newsucursal.map((item) => ({
        ...item,
        checked: savedState?.sucursal?.some((s) => s.idsucursal === item.idsucursal && s.checked),
      }));
    }

    setState({
      ...state,
      adr: newadr,
      sucursal: newsucursal,
      departamento: newdepartamento,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const onCargar = () => {
    if (state.ejercicio === undefined || state.ejercicio === null || state.ejercicio === "") {
      Swal.fire("CARTERA EN TRÁNSITO", "Favor de seleccionar el ejercicio", "warning");
      return;
    }
    if (state.periodo === undefined || state.periodo === null || state.periodo === "") {
      Swal.fire("CARTERA EN TRÁNSITO", "Favor de seleccionar el periodo", "warning");
      return;
    }

    // state.adr/state.sucursal son el catálogo completo (cada item trae su
    // propio "checked"); aquí nos quedamos solo con los que el usuario
    // realmente marcó, para no enviar todas las regiones/sucursales.
    const adrSeleccionados = (adr || []).filter((item) => item.checked);
    const sucursalSeleccionadas = (sucursal || []).filter((item) => item.checked);

    onOpenModal();
    guardarState(state);
    onExecute(state.ejercicio, state.periodo, sucursalSeleccionadas, adrSeleccionados, state.pendientes)
      .then(() => {})
      .catch((error) => {
        Swal.fire("CARTERA EN TRÁNSITO", JSON.stringify(error), "error");
      });
  };

  const labelclick = ({ target }) => {
    target.parentNode.firstChild.click();
  };

  const selectedClick = ({ target }, index) => {
    switch (target.name) {
      case "chk-adr": {
        var newarray = adr;
        newarray[index].checked = target.checked;

        var newarrarsucursal = [];
        var newarraydepartamento = [];
        var adrActive = [];
        newarray.forEach((item) => {
          if (item.checked) {
            adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
            newarrarsucursal = newarrarsucursal.concat(
              GroupByForeignKey(data, "idadr", item.idadr, ["idsucursal", "sucursal"])
            );
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idadr", item.idadr, ["iddepartamento", "departamento"])
            );
          }
        });
        onBoxChange("pv", {
          adr: adrActive,
          sucursal: [],
          departamento: [],
        });
        setState({
          ...state,
          adr: newarray,
          sucursal:
            newarrarsucursal.length === 0
              ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
              : GroupByPropCheck(newarrarsucursal, ["idsucursal", "sucursal"], false),
          departamento:
            newarraydepartamento.length === 0
              ? GroupByPropCheck(data, ["iddepartamento", "departamento"], false)
              : GroupByPropCheck(newarraydepartamento, ["iddepartamento", "departamento"], false),
        });
        break;
      }
      case "chk-sucursal": {
        var newarraySuc = sucursal;
        newarraySuc[index].checked = target.checked;

        var newarraydepartamentoSuc = [];
        var sucursalactiva = [];
        newarraySuc.forEach((item) => {
          if (item.checked) {
            sucursalactiva = [...sucursalactiva, { idsucursal: item.idsucursal, sucursal: item.sucursal }];
            newarraydepartamentoSuc = newarraydepartamentoSuc.concat(
              GroupByForeignKey(data, "idsucursal", item.idsucursal, ["iddepartamento", "departamento"])
            );
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: sucursalactiva,
          departamento: [],
        });
        setState({
          ...state,
          sucursal: newarraySuc,
          departamento:
            newarraydepartamentoSuc.length === 0
              ? GroupByPropCheck(data, ["iddepartamento", "departamento"], false)
              : GroupByPropCheck(newarraydepartamentoSuc, ["iddepartamento", "departamento"], false),
        });
        break;
      }
      default:
        break;
    }
  };

  const onChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
    onBoxChange(target.name, target.value);
  };

  return (
    <div className="filtros-pedidos-facturados">
      <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
        <FilterAltIcon /> Filtrar
      </div>
      <div className="mdl-filtro-resumen-cartera-abc" id="mdlFiltrosCarteraTransito-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={"modal-filtro-resumen-cartera-mensual"}
        >
          <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
            X
          </div>
          <div className="modal-filtro-resumen-cartera-mensual-container">
            <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
              <div className="filtro-tiempo-tipo">
                <div className="filtro-group">
                  <label>Ejercicio</label>
                  <EjercicioByRange name="ejercicio" value={state.ejercicio} onChange={onChange} />
                  <label>Periodo</label>
                  <PeriodoSelect name="periodo" value={state.periodo} onChange={onChange} />
                  <label>Estatus</label>
                  <select name="pendientes" value={state.pendientes} onChange={onChange}>
                    <option value={0}>Todos</option>
                    <option value={1}>Pendientes</option>
                    <option value={2}>Resueltos</option>
                  </select>
                </div>
                <div className="mdlFiltros-modal-acciones-guardar" onClick={onCargar}>
                  Cargar
                </div>
              </div>
              <div className="filtro-adr">
                <div className="title title-adr">Región</div>
                {adr?.map((item, index) => (
                  <div key={`${item.idadr}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-adr"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idadr}
                    />
                    <label onClick={labelclick}>{capitalizePalabras(item.adr)}</label>
                  </div>
                ))}
              </div>
              <div className="filtro-sucursal">
                <div className="title title-sucursal">Sucursal</div>
                {sucursal?.map((item, index) => (
                  <div key={`${item.idsucursal}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-sucursal"
                      className="my-checkbox"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idsucursal}
                    />
                    <label onClick={labelclick}>{capitalizePalabras(item.sucursal)}</label>
                  </div>
                ))}
              </div>
            </div>
            <div className="mdlFiltros-modal-acciones"></div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};

export default FiltroCarteraTransito;
